import React from 'react';
import { useMode } from '../contexts/ModeContext';
import {
  LabsHero,
  LabsAgencyPresentation,
  LabsWebServices,
  LabsCallUpShowcase,
  Labs5StepProcess,
  LabsContact,
  LabsCalendly,
  CallUpHero,
  TrialSection,
} from './HomeSections';
import {
  CallUpKeyBenefits,
  CallUpPricing,
  CallUpAddons,
  CallUpTestimonials,
  CallUpFAQ
} from './CallUpSections';
import { 
  EnhancedHeroStats,
  ProblemSection,
  CallUpExampleSection
} from '../components/PremiumSections';
import {
  ROISection,
  ForWhoSection,
  LabsMarketingSection
} from '../components/PremiumSections2';

// =============================================
// MAIN - Structure complète selon les images fournies
// =============================================

const Home = () => {
  const { isLabs } = useMode();

  return (
    <main className={isLabs ? 'labs-mode' : 'callup-mode'}>
      {isLabs ? (
        <>
          {/* Labs Agency Mode */}
          <LabsHero />
          <LabsAgencyPresentation />
          <LabsWebServices />
          <LabsCallUpShowcase />
          <Labs5StepProcess />
          <LabsMarketingSection />
          <LabsCalendly />
          <LabsContact />
        </>
      ) : (
        <>
          {/* Call Up Mode - ENHANCED PREMIUM */}
          <CallUpHero />
          <EnhancedHeroStats />
          <TrialSection />
          <ProblemSection />
          <CallUpExampleSection />
          <ROISection />
          <CallUpKeyBenefits />
          <ForWhoSection />
          <CallUpPricing />
          <CallUpAddons />
          <CallUpTestimonials />
          <CallUpFAQ />
        </>
      )}
    </main>
  );
};

export default Home;
